import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

export const SKIP_ERROR_TOAST_HEADER = 'X-Skip-Error-Toast';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private snackBar: MatSnackBar) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const skipErrorToast = request.headers.has(SKIP_ERROR_TOAST_HEADER);
        const forwardedRequest = skipErrorToast
            ? request.clone({ headers: request.headers.delete(SKIP_ERROR_TOAST_HEADER) })
            : request;
        return next
            .handle(forwardedRequest)
            .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipErrorToast)));
    }

    private handleError(error: HttpErrorResponse, skipErrorToast: boolean) {
        if (error.status === 0) {
            console.error('An error occurred:', error.error);
        } else {
            console.error(`Backend returned code ${error.status}, body was: `, error.error);
        }
        if (!skipErrorToast) {
            this.displaySnackBar('Action failed. Please try again later.');
        }
        return throwError(error);
    }

    private displaySnackBar(message: string) {
        this.snackBar.open(message, null, {
            duration: 5000
        });
    }
}
